import { IToastr } from "../../models/IToastr";
import Avatar from "../Avatar";
import { Button } from "../Button";
import Typography from "../Typography";
import styles from "./Toastr.module.css";
import { X, WarningCircle, CheckCircle } from "@phosphor-icons/react";

const Toastr = (props: IToastr) => {
  const getFirstBtnLabel = () => {
    switch (props.type) {
      case "gray":
        return "Later";
      case "progress":
        return "Cancel";
      default:
        return "Dismiss";
    }
  };
  const getSecondBtnLabel = () => {
    switch (props.type) {
      case "gray":
        return "Install Now";
      case "error":
      case "warning":
        return "Undo action";
      case "success":
      case "none":
        return "View changes";
      case "progress":
        return "Upload another";
      default:
        return "Changelog";
    }
  };
  const getPrimaryIcon = () => {
    return <WarningCircle size={28} />;
  };

  const getSuccessIcon = () => {
    return <CheckCircle size={28} />;
  };

  const getIcon = () => {
    switch (props.type) {
      case "primary":
      case "error":
      case "warning":
        return getPrimaryIcon();
      case "success":
        return getSuccessIcon();
    }
  };

  const ImageContainer = () => {
    return (
      <div className={styles.image_container}>
        <img src={props.imageSrc} alt="Toastr Image" />
      </div>
    );
  };

  const AvatarContainer = () => {
    return (
      <Avatar
        statusIcon={props.statusIcon}
        size={props.iconSize || "md"}
        src_text={props.avatarText || ""}
        src={props.avatar || undefined}
        id={""}
        image_hash={""}
        mime_type={""}
        height={"24px"}
        width={"24px"}
      />
    );
  };
  return (
    <div className={styles["toastr_container"]}>
      {props.type === "image" && <ImageContainer />}
      <div className={styles.toastr}>
        <div className={`${styles["toaster_container"]}`}>
          {props.type !== "none" &&
            (props.type === "primary" ||
              props.type === "error" ||
              props.type === "warning" ||
              props.type === "success") && (
              <div
                className={`${styles.feature_icon} ${styles[`color_${props.iconColor}`]}`}
              >
                {getIcon()}
              </div>
            )}
          {props.type === "avatar" && (
            <div className={`${styles.feature_icon}`}>
              <AvatarContainer />
            </div>
          )}
          {(props.type === "gray" ||
            props.iconSrc ||
            props.type === "progress") && (
            <div
              className={`${styles.feature_icon} ${styles.custom_icon} ${styles["icon_" + props.iconSize || "md"]}`}
            >
              {props.iconSrc}
            </div>
          )}
          <div className={styles["main_content"]}>
            <div className={styles["toastr_body"]}>
              <div className={styles.content}>
                <div>
                  <Typography size="sm" color="primary" fontFamily="semibold">
                    {props.heading}
                  </Typography>
                </div>
                {props.supportingText && (
                  <div>
                    <Typography
                      size="sm"
                      color="secondary"
                      fontFamily="regular"
                    >
                      {props.supportingText}
                    </Typography>
                  </div>
                )}
              </div>
              <div className={styles.close} onClick={props.onClose}>
                <X size={18} />
              </div>
            </div>
            {props.actions && (
              <div className={`${styles.actions} d-flex`}>
                {props.type !== "error" && props.type !== "warning" && (
                  <Button
                    className={styles.action_btn1}
                    onClick={props.handleFirstAction}
                    buttonType="link"
                    label={""}
                    variant={"secondary"}
                  >
                    <Typography
                      size="sm"
                      color="tertiary"
                      fontFamily="semibold"
                    >
                      {getFirstBtnLabel()}
                    </Typography>
                  </Button>
                )}
                <Button
                  className={styles.action_btn2}
                  onClick={props.handleSecondAction}
                  buttonType="link"
                  label={""}
                  variant={"primary"}
                >
                  <Typography size="sm" fontFamily="semibold">
                    {getSecondBtnLabel()}
                  </Typography>
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toastr;
